import './bootstrap';

// ── Alpine components ─────────────────────────────────────────────────
// Registered from the bundle (loaded in <head>) so they exist before
// Alpine initializes any page DOM. Blade-inline registration raced
// wire:navigate - Alpine morphs the new body before its inline scripts
// re-run (Sentry: "floopRichText is not defined" / "html is not defined").

document.addEventListener('alpine:init', () => {
    if (window.__floopRichTextReg) return;
    window.__floopRichTextReg = true;

    // Rich-text editor (<x-rich-text>): current HTML lives in `html` and is
    // mirrored to a hidden wire:model input on every edit; paste is stripped
    // to plain text; toolbar uses execCommand (fine on evergreen browsers).
    window.Alpine.data('floopRichText', (initial, name) => ({
        initial: initial || '',
        html:    initial || '',
        name:    name || '',
        // Server-driven content swap (e.g. AI generation): wire:ignore means
        // Livewire can never repaint the editor, so the server dispatches
        // 'rich-text-set' {name, html} instead.
        onSet(d) {
            if (! d || d.name !== this.name) return;
            this.$refs.editor.innerHTML = d.html || '';
            this.sync();
        },
        cmd(c) { this.$refs.editor.focus(); document.execCommand(c, false, null); this.sync(); },
        link() {
            this.$refs.editor.focus();
            const url = prompt('הדבק כתובת קישור (https://...):', 'https://');
            if (! url) return;
            if (! /^(https?:|mailto:)/i.test(url)) { alert('כתובת לא חוקית.'); return; }
            document.execCommand('createLink', false, url);
            this.sync();
        },
        sync() {
            this.html = this.$refs.editor.innerHTML;
            const h = this.$refs.hidden;
            if (h && h.value !== this.html) {
                h.value = this.html;
                h.dispatchEvent(new Event('input', { bubbles: true }));
                h.dispatchEvent(new Event('change', { bubbles: true }));
            }
        },
        onPaste(e) {
            const text = (e.clipboardData || window.clipboardData).getData('text/plain');
            document.execCommand('insertText', false, text);
            this.sync();
        },
    }));

    // Global confirm dialog (<x-confirm-modal>), resolves window.floopConfirm.
    if (! window.__floopConfirmReg) {
        window.__floopConfirmReg = true;
        window.Alpine.data('floopConfirmModal', () => ({
            open: false,
            opts: { title: '', message: '', confirmLabel: '', cancelLabel: '', danger: false },
            show(detail) {
                this.opts = Object.assign({
                    title: 'רגע, לאשר?', message: '',
                    confirmLabel: 'אישור', cancelLabel: 'ביטול', danger: false,
                }, detail || {});
                this.open = true;
                this.$nextTick(() => this.$refs.confirmBtn?.focus());
            },
            choose(ok) {
                if (! this.open) return;
                this.open = false;
                var r = window.__floopConfirmResolve;
                window.__floopConfirmResolve = null;
                if (r) r(ok);
            },
        }));
    }
});

if (! window.floopConfirm) {
    window.floopConfirm = function (opts) {
        return new Promise(function (resolve) {
            // A second dialog while one is open cancels the first.
            if (window.__floopConfirmResolve) window.__floopConfirmResolve(false);
            window.__floopConfirmResolve = resolve;
            window.dispatchEvent(new CustomEvent('floop-confirm-open', { detail: opts || {} }));
        });
    };
}

// ── Global toast/snackbar ─────────────────────────────────────────────
// Livewire components dispatch('toast', message: '...') - render it as a
// bottom-center snackbar. DOM built on the fly; no blade markup needed.
window.addEventListener('toast', (e) => {
    const msg = e.detail?.message || (Array.isArray(e.detail) ? e.detail[0]?.message : '') || '';
    if (! msg) return;
    const el = document.createElement('div');
    el.dir = 'rtl';
    el.textContent = msg;
    el.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(8px);' +
        'background:#0f172a;color:#fff;padding:10px 18px;border-radius:12px;font-size:14px;font-weight:600;' +
        'box-shadow:0 8px 24px rgba(0,0,0,.25);z-index:200;opacity:0;transition:opacity .2s,transform .2s;max-width:90vw;';
    document.body.appendChild(el);
    requestAnimationFrame(() => { el.style.opacity = '1'; el.style.transform = 'translateX(-50%)'; });
    setTimeout(() => {
        el.style.opacity = '0'; el.style.transform = 'translateX(-50%) translateY(8px)';
        setTimeout(() => el.remove(), 250);
    }, 3500);
});
